'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'face-vomit';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a0';
var svgPathData = 'M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3L97.2 426.7C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7L455 405.3c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM153.8 182l15.9-27.8 13.9 7.9 56 32L263.9 208l-24.3 13.9-56 32-13.9 7.9L153.8 234l13.9-7.9L199.4 208l-31.7-18.1L153.8 182zm254.5 7.9L376.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L312.1 208l24.3-13.9 56-32 13.9-7.9L422.2 182l-13.9 7.9zM16 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-63.4-78c-19 10.6-32.6 24.7-43.8 39.6l-25.6-19.2c12.8-17.1 29.7-35 53.9-48.4c24.3-13.5 55-22 94.9-22s70.7 8.5 94.9 22c24.2 13.4 41 31.3 53.9 48.4l-25.6 19.2c-11.2-14.9-24.8-29-43.8-39.6c-19-10.5-44.2-18-79.4-18s-60.4 7.5-79.4 18zm11.7 21c1.2-.7 2.5-1.3 3.7-2l0 19.9c0 39.8-21.2 76.7-55.6 96.7l-11 6.4 261.1 0-11-6.4c-34.4-20.1-55.6-56.9-55.6-96.7l0-19.9c1.3 .6 2.5 1.3 3.7 2c11.3 6.3 20.4 14.2 28.4 23.4c1.8 26.3 16.5 50.2 39.5 63.6l48.4 28.2 7.9 4.6 0 9.2 0 8 0 16-16 0-352 0-16 0 0-16 0-8 0-9.2 7.9-4.6L152.3 446c23-13.4 37.7-37.3 39.5-63.6c8-9.1 17.1-17.1 28.4-23.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceVomit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;